module.exports = __webpack_public_path__ + "static/cf-bold-7f130f31aa16dbf57a91ca08a5ec8cfc.ttf";